
class ImWebRtc {
	constructor() {
		this.configuration = {}
		this.stream = null;
	}
}

ImWebRtc.prototype.isEnable = function () {
	window.RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window
		.mozRTCPeerConnection;
	window.RTCSessionDescription = window.RTCSessionDescription || window.webkitRTCSessionDescription || window
		.mozRTCSessionDescription;
	window.RTCIceCandidate = window.RTCIceCandidate || window.webkitRTCIceCandidate || window
		.mozRTCIceCandidate;
	return !!window.RTCPeerConnection;
}

ImWebRtc.prototype.init = function (configuration) {
	this.configuration = configuration;
}

ImWebRtc.prototype.setupPeerConnection = function (callback) {
	this.peerConnection = new RTCPeerConnection(this.configuration);
	
	// 监听远程轨道
	this.peerConnection.ontrack = (e) => {
		console.log('收到远程轨道:', e);
		console.log('轨道信息:', e.track ? {
			kind: e.track.kind,
			id: e.track.id,
			enabled: e.track.enabled,
			readyState: e.track.readyState
		} : '无轨道');
		console.log('流信息:', e.streams ? e.streams.map(s => ({
			id: s.id,
			active: s.active,
			tracks: s.getTracks().map(t => ({ kind: t.kind, id: t.id }))
		})) : '无流');
		
		// 对方的视频流
		if (e.streams && e.streams.length > 0) {
			callback(e.streams[0]);
		} else if (e.track) {
			// 如果没有流但有轨道，创建一个新的流
			const stream = new MediaStream([e.track]);
			callback(stream);
		}
	};
	
	// 监听连接状态变化
	this.peerConnection.onconnectionstatechange = () => {
		console.log('连接状态变化:', this.peerConnection.connectionState);
	};
	
	// 监听信令状态变化
	this.peerConnection.onsignalingstatechange = () => {
		console.log('信令状态变化:', this.peerConnection.signalingState);
	};
}


ImWebRtc.prototype.setStream = function (stream) {
	if (this.stream) {
		// 移除旧的轨道
		this.peerConnection.getSenders().forEach(sender => {
			if (sender.track) {
				this.peerConnection.removeTrack(sender);
			}
		});
	}
	if (stream) {
		stream.getTracks().forEach((track) => {
			this.peerConnection.addTrack(track, stream);
		});
	}
	this.stream = stream;
}

// 设置本地流（用于屏幕分享等场景）
ImWebRtc.prototype.setLocalStream = function (stream) {
	console.log('ImWebRtc.setLocalStream 被调用:', stream);
	
	if (!stream) {
		console.error('流为空，无法设置');
		return;
	}
	
	// 移除旧的轨道
	if (this.peerConnection) {
		const senders = this.peerConnection.getSenders();
		console.log('当前发送器数量:', senders.length);
		
		senders.forEach(sender => {
			if (sender.track) {
				console.log('移除轨道:', sender.track.kind, sender.track.id);
				this.peerConnection.removeTrack(sender);
			}
		});
		
		// 添加新的轨道
		stream.getTracks().forEach(track => {
			console.log('添加新轨道:', track.kind, track.id);
			this.peerConnection.addTrack(track, stream);
		});
		
		this.stream = stream;
		console.log('✅ 本地流设置完成，轨道数量:', stream.getTracks().length);
	} else {
		console.error('PeerConnection未初始化');
	}
}


ImWebRtc.prototype.onIcecandidate = function (callback) {
	this.peerConnection.onicecandidate = (event) => {
		// 追踪到候选信息
		if (event.candidate) {
			callback(event.candidate)
		}
	}
}

ImWebRtc.prototype.onStateChange = function (callback) {
	// 监听连接状态
	this.peerConnection.oniceconnectionstatechange = (event) => {
		let state = event.target.iceConnectionState;
		console.log("ICE连接状态变化: : " + state)
		callback(state)
	};
}

// 获取连接状态
ImWebRtc.prototype.getConnectionState = function () {
	if (this.peerConnection) {
		return this.peerConnection.iceConnectionState;
	}
	return 'unknown';
}

ImWebRtc.prototype.createOffer = function () {
	return new Promise((resolve, reject) => {
		const offerParam = {};
		offerParam.offerToRecieveAudio = 1;
		offerParam.offerToRecieveVideo = 1;
		// 创建本地sdp信息
		this.peerConnection.createOffer(offerParam).then((offer) => {
			// 设置本地sdp信息
			return this.peerConnection.setLocalDescription(offer).then(() => {
				// 发起呼叫请求
				resolve(offer)
			});
		}).catch((e) => {
			reject(e)
		})
	});
}


ImWebRtc.prototype.createAnswer = function (offer) {
	return new Promise((resolve, reject) => {
		const setRemoteDescription = offer ? this.setRemoteDescription(offer) : Promise.resolve();
		setRemoteDescription.then(() => {
			// 创建本地dsp
			const offerParam = {};
			offerParam.offerToRecieveAudio = 1;
			offerParam.offerToRecieveVideo = 1;
			this.peerConnection.createAnswer(offerParam).then((answer) => {
				// 设置本地sdp信息
				return this.peerConnection.setLocalDescription(answer).then(() => {
					// 接受呼叫请求
					resolve(answer)
				});
			}).catch((e) => {
				reject(e)
			})
		}).catch((e) => {
			reject(e)
		})
	});
}

ImWebRtc.prototype.setRemoteDescription = function (offer) {
	// 设置对方的sdp信息
	return this.peerConnection.setRemoteDescription(new RTCSessionDescription(offer));
}

ImWebRtc.prototype.addIceCandidate = function (candidate) {
	// 添加对方的候选人信息
	return this.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
}

ImWebRtc.prototype.close = function (uid) {
	// 关闭RTC连接
	if (this.peerConnection) {
		this.peerConnection.close();
		this.peerConnection.onicecandidate = null;
		this.peerConnection.ontrack = null;
		this.peerConnection.onaddstream = null;
		this.peerConnection.oniceconnectionstatechange = null;
		this.peerConnection.onconnectionstatechange = null;
		this.peerConnection.onsignalingstatechange = null;
		this.peerConnection = null;
	}
	this.stream = null;
}

export default ImWebRtc;
